export const boxBorderRadius = "8px";

export default `
  --box-border-radius: ${boxBorderRadius};
  --outline-width: 2px;
  --outline-offset: 2px;
`;
